import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {MouseEvent} from 'react';

import {NotificationsBadge, NotificationsButton} from './notifications.styles';

interface NotificationsTriggerProps {
  onOpen: (event: MouseEvent<HTMLElement>) => void;
  newNotificationsCount: number;
}

export const NotificationsTrigger = ({onOpen, newNotificationsCount}: NotificationsTriggerProps) => {
  return (
    <NotificationsButton onClick={onOpen} aria-label="Уведомления">
      <NotificationsBadge badgeContent={newNotificationsCount} invisible={!newNotificationsCount}>
        <NotificationsNoneIcon />
      </NotificationsBadge>
    </NotificationsButton>
  );
};
